import { render } from "./ClientDetail.vue?vue&type=template&id=5c92b315&scoped=true"
import script from "./ClientDetail.vue?vue&type=script&lang=js"
export * from "./ClientDetail.vue?vue&type=script&lang=js"

import "./ClientDetail.vue?vue&type=style&index=0&id=5c92b315&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c92b315"],['__file',"src/views/AfterSales/applyAfterSalesAndsubFunc/ClientDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c92b315"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c92b315', __exports__)) {
    api.reload('5c92b315', __exports__)
  }
  
  module.hot.accept("./ClientDetail.vue?vue&type=template&id=5c92b315&scoped=true", () => {
    api.rerender('5c92b315', render)
  })

}


export default __exports__